import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=b456277a&"
import script from "./Filters.vue?vue&type=script&lang=ts&"
export * from "./Filters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports